function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M102.7,94c8.8-3.9,22.2-11.9,22.2-22.5c0-4.5-3.5-8.3-9.4-8.3c-1.8,0-12.1,0-21.4,0c-9.3,0-19.6,0-21.4,0 c-5.9,0-9.4,3.8-9.4,8.3C63.2,82,76.5,90.1,85.3,94c2.1,2.1,4.5,4.4,7.4,6.8c0,2.8,0,6.3,0,8.6H74.3c-0.6,0-1,0.5-1,1v16.4 c0,0.6,0.5,1,1,1h39.3c0.6,0,1-0.5,1-1v-16.4c0-0.6-0.5-1-1-1H95.3c0-2.3,0-5.8,0-8.6C98.1,98.3,100.6,96.1,102.7,94z M112.1,125.4 H75.8v-13.5h36.4V125.4z M114.8,65.4c5.1,0,7.4,3.3,7.4,6.3c0,6.1-5.9,11.9-15.2,17.5c6.2-7.7,7.6-13.9,7.6-21.5c0-1.2,0-1.5,0-2.3 C114.7,65.4,114.8,65.4,114.8,65.4z M65.8,71.6c0-3,2.3-6.3,7.4-6.3c0,0,0.1,0,0.2,0c0,0.8,0,1.1,0,2.3c0,7.5,1.4,13.8,7.6,21.5 C71.7,83.6,65.8,77.8,65.8,71.6z M75.9,67.9c0-0.9,0-1.8,0-2.5c0.7,0,1.5,0,2.4,0c10.1,0,31.4,0,31.4,0c0.9,0,1.7,0,2.4,0 c0,0.7,0,1.6,0,2.5c0,11.5-6.6,21.1-18,30.6c-0.1,0.1-0.2,0.1-0.3,0C82.4,89,75.9,79.4,75.9,67.9z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M159.6,121.1L186.8,94l-27.1-27.1V28.5h-38.4L94.1,1.3L67,28.5H28.5v38.4L1.4,94l27.1,27.1v38.4H67l27.1,27.1 l27.1-27.1h38.4V121.1z M94.1,143.2c-27.1,0-49.2-22-49.2-49.2s22-49.2,49.2-49.2s49.2,22,49.2,49.2S121.2,143.2,94.1,143.2z"
});

var SvgTh3 = function SvgTh3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "PrinciplesCariera",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188 188",
    style: {
      enableBackground: "new 0 0 188 188"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTh3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/th-3.383cd675.svg";
export { ForwardRef as ReactComponent };